import React from "react";
// SCSS
import "./teamInfo.scss";

const about = () => (
  <div className="team__info flex-center">
    <div>
      <h4 className="font20 weight800">Um pouco mais sobre nós</h4>
      <p className="font12 weight500" style={{maxWidth:"500px", textAlign:"justify"}}>
      Combinamos criatividade e estratégia para entregar projetos únicos e personalizados. Nossa visão é construir conexões fortes entre pessoas e marcas, sempre priorizando inovação e excelência.
      </p>
    </div>
  </div>
);

export default about;
